<!--
 * @Descripttion:
 * @version:
 * @Author: AowCt <awoct10@163.com>
 * @Date: 2021-11-08 17:53:58
 * @LastEditors: AowCt <awoct10@163.com>
 * @LastEditTime: 2023-04-06 13:53:00
-->
<template>
  <div >
    <div class="index-banner">
      <div class="swiper" id="indexBanner">
        <div class="swiper-wrapper">
          <div class="swiper-slide index-banner-page1">
            <img class="index-banner-list-bjimg" :src="require('@/assets/images/index/banner/banner1.png')" alt="" srcset="">
            <div class="index-banner-list-wrap">
              <div class="index-banner-list-title"><p v-for="(item, index) in $t('frontPage.banner.banner1.title')" v-html="item" :key="index"></p></div>
              <div class="index-banner-list-des"><span v-for="(item, index) in $t('frontPage.banner.banner1.des')" v-html="item" :key="index"></span></div>
            </div>
          </div>
          <div class="swiper-slide index-banner-page2">
            <img class="index-banner-list-bjimg" :src="require('@/assets/images/index/banner/banner2.png')" alt="" srcset="">
            <div class="index-banner-list-wrap">
              <div class="index-banner-list-title"><p v-for="(item, index) in $t('frontPage.banner.banner2.title')" v-html="item" :key="index"></p></div>
              <div class="index-banner-list-des"><span v-for="(item, index) in $t('frontPage.banner.banner2.des')" v-html="item" :key="index"></span></div>
            </div>
          </div>
          <div class="swiper-slide index-banner-page3 flex align_items_center justify_content_center">
            <img class="index-banner-list-video" :src="require('@/assets/images/index/banner/banner3.gif')" alt="" srcset=""/>
            <div class="index-banner-list-wrap">
              <div class="index-banner-list-title"><p v-for="(item, index) in $t('frontPage.banner.banner3.title')" v-html="item" :key="index"></p></div>
              <div class="index-banner-list-des"><span v-for="(item, index) in $t('frontPage.banner.banner3.des')" v-html="item" :key="index"></span></div>
            </div>
          </div>
        </div>
        <div ref="pagination" class="swiper-pagination index-banner-pagination"></div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  data () {
    return {
    }
  },
  mounted () {
    this.mySwiper = new this.$Swiper('#indexBanner', {
      autoplay: {
        delay: 3000,
        disableOnInteraction: false
      },
      effect: 'fade',
      pagination: {
        el: '.index-banner-pagination',
        bulletElement: 'li',
        clickable: true
      },
      on: {
        click: function (swiper) {
          if (swiper.target.nodeName === 'LI') {
            this.autoplay.stop()
            var timer = setTimeout(() => {
              this.autoplay.start()
              clearTimeout(timer)
              timer = null
            }, 10000)
          }
        }
      }
    })
  },
  methods: {
  }
}
</script>

<style lang="less" scoped>
.index-banner{
  .swiper {
    height: 100vh;
    .swiper-slide {
      position: relative;
      overflow: hidden;
    }
  }
  // padding-top: 192PX;
  // margin-bottom: 90PX;
  position: relative;
  color: #ffffff;
  .index-banner-list-bjimg{
      width: 100%;
      height: 100%;
      transform: scale(1.2, 1.2);
      -webkit-transform: scale(1.2, 1.2);
      -moz-transform: scale(1.2, 1.2);
      -ms-transform: scale(1.2, 1.2);
      -o-transform: scale(1.2, 1.2);
      // animation: enlarge 3s infinite;
  }
  .index-banner-list-video {
    height: 70%;
    transform: rotate(180deg);
  }
  .index-banner-list-wrap{
    position: absolute;
    top: 0;
    text-align: center;
    width: 100%;
    overflow: hidden;
    height: 100%;
    background: rgba(0, 0, 0, 0.4);
    .index-banner-list-title {
      font-size: 60PX;
      font-weight: 300;
      line-height: 84PX;
      letter-spacing: 2PX;
      font-weight: bold;
      opacity: 0;
      position: absolute;
      width: 100%;
      top: 40vh;
    }
    .index-banner-list-des {
      font-size: 20PX;
      line-height: 58PX;
      opacity: 0;
      position: absolute;
      width: 100%;
      color: rgba(255, 255, 255, 0.8);
      top: calc(40vh + 80PX);
    }

      // transition: opacity 2s ease 1s;
  }
  .swiper-slide {
    &.index-banner-page1 {
      .index-banner-list-title{
        left: -100%;
        // letter-spacing: 14PX;
      }
      .index-banner-list-des {
        right: -100%;
      }
    }
    &.index-banner-page2 {
      .index-banner-list-title{
        top: 0;
      }
      .index-banner-list-des {
        top: calc(80PX);
      }
    }
    &.index-banner-page3 {
      background: #121023;
      .index-banner-list-title, .index-banner-list-des {
        opacity: 1;
      }
    }
  }
  .swiper-slide-active{
    .index-banner-list-bjimg{
      animation: enlarge 3s;
    }
    &.index-banner-page1 {
      .index-banner-list-title{
        opacity: 1;
        left: 0;
        transition: opacity 2s ease,left 2s ease;
      }
      .index-banner-list-des {
        opacity: 1;
        right: 0;
        transition: opacity 2s ease,right 2s ease;
      }
    }
    &.index-banner-page2 {
      .index-banner-list-title{
        opacity: 1;
        top: 40vh;
        transition: opacity 2s ease .5s,top 1s ease .5s;
      }
      .index-banner-list-des {
        opacity: 1;
        top: calc(40vh + 80PX);
        transition: opacity 2s ease .5s,top 1s ease .5s;
      }
    }
  }
}
.pc.en {
  .index-banner-list-title {
    font-size: 36PX;
  }
}
</style>

<style lang="less">
.index-banner{
  .index-banner-pagination {
    position: absolute;
    height: 24PX;
    bottom: 10%;
    .swiper-pagination-bullet {
      width: 28PX;
      height: 10PX;
      // background: #91DEFF;
      background: #ffffff;
      opacity: 0.3;
      margin: 0 16PX;
      border-radius: 7PX;
      transition: width 0.3s;
    }
    .swiper-pagination-bullet-active {
      width: 42PX;
      margin: 0 9PX;
      background: #ffffff;
      opacity: 1;
    }
  }
}
</style>

<style lang="less" scoped>
@media screen and (max-width: 1600PX) {
  .pc:not(.en) .index-banner{
    .index-banner-list-wrap{
      .index-banner-list-title {
        font-size: 40PX;
      }
    }
  }
}
</style>
